document.addEventListener("DOMContentLoaded", () => {
  const translations = window.contactFormTranslation || {
    consentText: "",
    consentError: "",
  };

  const formBlock = document.querySelector(".form-block-selector");

  const locationsBlock = document.querySelector(".locations-block-selector");

  if (formBlock && locationsBlock) {
    const placeholder = document.createElement("div");
    placeholder.id = "form-block-original-placeholder";
    placeholder.style.display = "none";
    formBlock.parentNode.insertBefore(placeholder, formBlock);

    function moveFormBasedOnScreen() {
      const isMobile = window.matchMedia("(max-width: 990px)").matches;

      if (isMobile) {
        if (locationsBlock.parentNode) {
          locationsBlock.parentNode.insertBefore(formBlock, locationsBlock);
        }
      } else {
        if (placeholder.parentNode) {
          placeholder.parentNode.insertBefore(
            formBlock,
            placeholder.nextSibling
          );
        }
      }
    }

    moveFormBasedOnScreen();

    window.addEventListener("resize", moveFormBasedOnScreen);
  }

  const observer = new MutationObserver(() => {
    const app = document.querySelector("#app-embed");
    if (!app || !app.shadowRoot) return;

    observer.disconnect();
    const shadow = app.shadowRoot;

    const form = shadow.querySelector('form[data-testid="form"]');
    const submitBtn = shadow.querySelector('button[type="submit"]');
    if (!form || !submitBtn) return;

    const sheet = new CSSStyleSheet();

    sheet.insertRule(`
      .custom-consent__label {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        cursor: pointer;
        user-select: none;
        font-family: DM Sans;
        font-size: 14px;
        line-height: 20px;
        color: #3F3F3F;
      }
    `);

    sheet.insertRule(`
      .custom-consent__input {
        position: absolute;
        opacity: 0;
        pointer-events: none;
      }
    `);

    sheet.insertRule(`
      .custom-consent__checkbox {
        width: 32px;
        height: 32px;
        border: 1px solid #D0CFCB;
        border-radius: 4px;
        flex-shrink: 0;
        position: relative;
        box-sizing: border-box;
        transition: all 0.2s ease;
      }
    `);

    sheet.insertRule(`
      .custom-consent__input:checked + .custom-consent__checkbox {
        background-color: #C71726;
        border-color: #C71726;
      }
    `);

    sheet.insertRule(`
      .custom-consent__input:checked + .custom-consent__checkbox::after {
        content: '';
        position: absolute;
        left: 10px;
        top: 1px;
        width: 10px;
        height: 18px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    `);

    sheet.insertRule(`
      .custom-consent__text {
        font-family: DM Sans;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
      }
    `);

    sheet.insertRule(`
      ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 ._formHeader_cit2d_24 {
        margin: 0;
        margin-bottom: 28px;
      }
    `);

    sheet.insertRule(`
      ._formHeader_cit2d_24 ._textHeading_2aowh_35 {
        margin: 0;
        margin-bottom: 20px;
        font-family: Lexend Deca;
        font-size: 28px;
        font-weight: 400;
        line-height: 130%;
        text-align: start;
      }
    `);

    sheet.insertRule(`
      ._formHeader_cit2d_24 ._textBody_2aowh_10 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: start;
      }
    `);

    sheet.insertRule(`
      form._formFieldset_cit2d_82 {
        gap: 20px;
      }
    `);

    sheet.insertRule(`
      div._formFieldContainer_1mxsl_5 {
        flex-direction: column-reverse;
        gap: 8px;
      }
    `);

    sheet.insertRule(`
      ._formPhoneInputContainer_piv1u_6 {
        align-items: flex-end;
      }
    `);

    sheet.insertRule(`
      label._formInputFieldLabel_1mxsl_38 {
        position: static;
        font-family: DM Sans;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #3F3F3F;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
        transform: unset;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74 {
        transform: unset;
        position: relative;
        top: 0 !important;
        left: unset;
        right: 100px;
      }
    `);

    sheet.insertRule(`
      ._selectToggle_12thd_25 {
        max-height: 48px !important;
      }
    `);

    sheet.insertRule(`
      button._formSubmitButton_cit2d_96 {
        width: fit-content;
        font-family: Lexend Deca;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        width: 273;
        height: 52px;
        border-radius: 6px;
        padding-top: 12px;
        padding-right: 35px;
        padding-bottom: 12px;
        padding-left: 35px;
        color: white;
        background: #C71726;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      @media screen and (max-width: 990px) {
        button._formSubmitButton_cit2d_96 {
            width: 100% !important;
          }
        }
    `);

    sheet.insertRule(`
      input._formInputField_nag3b_7 {
        height: 48px !important;
        padding: 12px 16px !important;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      input._formPhoneInputField_piv1u_17 {
        height: 48px !important;
        padding: 12px 16px !important;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      ._formBannerContainer_z5ku3_1 {
        margin-top: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        justify-content: flex-end !important;
        text-align: start !important;
      }
    `);

    sheet.insertRule(`
      ._formBannerHeading_z5ku3_9 {
        margin-bottom: 20px !important;
        font-family: Lexend Deca !important;
        font-size: 28px !important;
        line-height: 130% !important;
        font-weight: 400 !important;
        color: #262626 !important;
        text-align: start !important;
      }
    `);

    sheet.insertRule(`
      ._textBody_2aowh_10 {
        max-width: 370px !important;
        font-size: 16px !important;
        line-height: 24px !important;
        font-weight: 400 !important;
      }
    `);

    shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];

    if (!shadow.querySelector(".custom-consent")) {
      const consent = document.createElement("div");
      consent.className = "custom-consent";

      consent.innerHTML = `
        <label class="custom-consent__label">
          <input type="checkbox" required class="custom-consent__input" />
          <span class="custom-consent__checkbox"></span>
          <span class="custom-consent__text">
             ${translations.consentText}
          </span>
        </label>
      `;

      submitBtn.before(consent);

      const checkbox = consent.querySelector(".custom-consent__input");

      form.addEventListener("submit", (e) => {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();

          checkbox.setCustomValidity(translations.consentError);
          checkbox.reportValidity();
        } else {
          checkbox.setCustomValidity("");
        }
      });

      form.addEventListener("submit", (e) => {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
